import { render, staticRenderFns } from "./AddSetupCommission.vue?vue&type=template&id=da6a7f38&"
import script from "./AddSetupCommission.vue?vue&type=script&lang=js&"
export * from "./AddSetupCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports